export const LOAD_TEMPLATES = 'certifications/LOAD_TEMPLATES';
export const ADD_TEMPLATE = 'certifications/ADD_TEMPLATE';
export const EDIT_TEMPLATE = 'certifications/EDIT_TEMPLATE';
export const REMOVE_TEMPLATE = 'certifications/REMOVE_TEMPLATE';
